const localStorageKeys = {
    userData: 'userData',
    refererHost: 'refererHost',
};
export const typedLocalStorage = {
    setItem(key, value) {
        localStorage.setItem(key, value);
    },
    getItem(key) {
        return localStorage.getItem(key) || null;
    },
};
